// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3rvHH","content":"GlobalSearch_content__21GgK"};